import { IntlShape } from 'react-intl';
import { CountryData } from 'types/wellGuardian';

import { WIRCreateJourneyStepsKeys } from '../wir.constants';

export const getStepLabel = (label: string, intl: IntlShape, countrySelect: string) => {
  if (countrySelect === CountryData.denmark) {
    switch (label) {
      case WIRCreateJourneyStepsKeys.STAGE_GATE_1:
        return intlSh(intl, 'stageGate1');
      case WIRCreateJourneyStepsKeys.STAGE_GATE_2:
        return intlSh(intl, 'stageGate2');
      case WIRCreateJourneyStepsKeys.STAGE_GATE_3:
        return intlSh(intl, 'stageGate3');
      case WIRCreateJourneyStepsKeys.STAGE_GATE_4:
        return intlSh(intl, 'stageGate4');
      case WIRCreateJourneyStepsKeys.STAGE_GATE_5:
        return intlSh(intl, 'stageGate5');
      case WIRCreateJourneyStepsKeys.REACTIVE_SCOPE:
        return intlSh(intl, 'reactiveScopeLabel');
    }
  } else {
    switch (label) {
      case WIRCreateJourneyStepsKeys.WIR_CREATED:
      case WIRCreateJourneyStepsKeys.CG_WIR_CREATED:
        return intlSh(intl, 'wirCratedPhaseLabel');
      case WIRCreateJourneyStepsKeys.KICK_OFF_TECHNICAL_WIR:
        return intlSh(intl, 'komTechnicalWirPhaseLabel');
      case WIRCreateJourneyStepsKeys.CG_KICK_OFF_TECHNICAL_WIR:
        return intlSh(intl, 'scopeValidationPhaseLabel');
      case WIRCreateJourneyStepsKeys.ENGINEERING_WORK:
      case WIRCreateJourneyStepsKeys.CG_ENGINEERING_WORK:
      case WIRCreateJourneyStepsKeys.AG_ENGINEERING_WORK:
      case WIRCreateJourneyStepsKeys.IRAQ_ENGINEERING_WORK:
      case WIRCreateJourneyStepsKeys.ARGENTINA_ENGINEERING_WORK:
        return intlSh(intl, 'engineeringWorkPhaseLabel');
      case WIRCreateJourneyStepsKeys.FINAL_WIR:
      case WIRCreateJourneyStepsKeys.CG_FINAL_WIR:
      case WIRCreateJourneyStepsKeys.IRAQ_FINAL_WIR:
      case WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_WIR:
        return intlSh(intl, 'finalWirPhaseLabel');
      case WIRCreateJourneyStepsKeys.AG_FINAL_WIR:
        return intlSh(intl, 'AgFinalWirPhaseLabel');
      case WIRCreateJourneyStepsKeys.FINAL_PREPARATION:
      case WIRCreateJourneyStepsKeys.NG_FINAL_PREPARATION:
      case WIRCreateJourneyStepsKeys.CG_FINAL_PREPARATION:
      case WIRCreateJourneyStepsKeys.IRAQ_FINAL_PREPARATION:
      case WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_PREPARATION:
        return intlSh(intl, 'finalPreparationPhaseLabel');
      case WIRCreateJourneyStepsKeys.AG_FINAL_PREPARATION:
        return intlSh(intl, 'AgFinalPreparationPhaseLabel');
      case WIRCreateJourneyStepsKeys.INTERVENTION_OPERATION:
      case WIRCreateJourneyStepsKeys.NG_INTERVENTION_OPERATION:
      case WIRCreateJourneyStepsKeys.CG_INTERVENTION_OPERATION:
      case WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION:
      case WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_OPERATION:
        return intlSh(intl, 'interventionOperationPhaseLabel');
      case WIRCreateJourneyStepsKeys.AG_INTERVENTION_OPERATION:
        return intlSh(intl, 'AgInterventionOperationPhaseLabel');
      case WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT:
      case WIRCreateJourneyStepsKeys.NG_INTERVENTION_CLOSE_OUT:
      case WIRCreateJourneyStepsKeys.CG_INTERVENTION_CLOSE_OUT:
      case WIRCreateJourneyStepsKeys.AG_INTERVENTION_CLOSE_OUT:
      case WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_CLOSE_OUT:
      case WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_CLOSE_OUT:
        return intlSh(intl, 'interventionCloseoutPhaseLabel');
      case WIRCreateJourneyStepsKeys.REACTIVE_SCOPE:
        return intlSh(intl, 'reactiveScopeLabel');
    }
  }
};

const intlSh = (intl: IntlShape, data: string) => {
  return intl.formatMessage({
    id: `wellGuardian.wir.wirCreation.${data}`,
  });
};
